export default {

  // ダイアログ タイトル
  /** 情報 : 情報表示（処理終了等）、ガイダンス等 */
  'dialog.title.I': '確認',
  /** 警告 : 入力チェックでの警告（処理継続可） */
  'dialog.title.W': '警告',
  /** エラー : 入力チェック、処理実行時のエラー（処理継続不可） */
  'dialog.title.E': '注意',
  /** 確認 : 処理継続の確認メッセージ */
  'dialog.title.C': '確認',
  /** システムエラー : サーバ、ネットワーク等の環境によるエラー 予期しないエラー */
  'dialog.title.S': 'システムエラー',

  // メッセージ
  // 共通（システム共通）
  'message.TKSCS00001S': '予期せぬエラーが発生しました。管理者に連絡してください。',
  'message.TKSCS00002C': '{0}します。よろしいですか。',
  'message.TKSCS00003C': '{0}を{1}します。よろしいですか。',
  'message.TKSCS00004I': '{0}しました。',
  'message.TKSCS00005E': '{0}を入力してください。{1}',
  'message.TKSCS00006E': '{0}は数値を入力してください。',
  'message.TKSCS00007E': '{0}に正しい日付を入力してください。',
  'message.TKSCS00008E': '{0}は正しい時刻を入力してください。',
  'message.TKSCS00009E': '{0}の桁数が超過しています。{1}',
  'message.TKSCS00010E': '{0}は{1}以前を入力してください。',
  'message.TKSCS00011E': '{0}の{1}に失敗しました。',
  'message.TKSCS00012E': '{0}ため、{1}できません。',
  'message.TKSCS00013E': '入力に誤りがあります。入力内容を確認してください。',
  'message.TKSCS00014W': '本画面でエラーが残っている状態で保存しています。登録までにエラーを取り除いてください。',
  'message.TKSCS00015E': '{0}が、{1}のため、入力できません。',
  'message.TKSCS00016E': 'メールアドレスに正しい値を入力してください。{0}',
  'message.TKSCS00017E': '他のユーザーによって更新されています。操作をやり直してください。',
  'message.TKSCS00018I': '仮パスワードでのログインのため，パスワードを変更してください。',
  'message.TKSCZ00019E': '誤ったユーザーIDまたはパスワードが入力されました。\n再度入力してください。',
  'message.TKSCZ00020I': 'パスワードを変更しました。\n新しいパスワードでログインしてください。',
  'message.TKSCZ00021I': [
    'パスワードリセットのメールを送付しました。',
    'メールに記載のURLをクリックして新しいパスワードを入力してください。',
    '',
    '数分経過してもメールが届かない場合、以下をご確認ください。',
    '・迷惑メールに振り分けられている場合があります。',
    '　メールが迷惑メールフォルダに届いていないかご確認ください。',
    '・ドメイン受信設定が必要な場合があります。',
    '　pnet.energia.co.jpからのメールを受信できるよう設定してください。',
    '・ご入力のユーザIDが誤っている場合があります。',
    '　ユーザIDは大文字と小文字を区別します。',
  ].join('\n'),
  'message.TKSCZ00022E': 'ユーザの有効期限が切れました。管理者に連絡してください。',
  'message.TKSCZ00023E': '{0}は無効なユーザです。',
  'message.TKSCZ00024E': 'メールアドレスドメインが間違っています。',
  // 有効フラグのチェック
  'message.TKSCZ00025E': 'ユーザが無効です。管理者に連絡してください。',
  'message.TKSCZ00026E': '{0}の有効期限が切れました。',
  'message.TKSCS00027S': '予期せぬエラーが発生しました。\nログイン画面から再度やり直してください。',
  'message.TKSCS00028E': '{0}対象を選択してください。',
  'message.TKSCS00029E': '{0}は4桁の整数を入力してください。{1}',
  'message.TKSCA00030E': '次回調査年度は{0}で入力してください。{1}',
  'message.TKSCA00031E': '次回調査年度は{0}以内で入力してください。{1}',
  'message.TKSCA00032E': '次回調査年度は{0}～{1}以内で入力してください。{2}',
  'message.TKSCA00033E': '申請中の調査業種データが存在している。承認完了まで再申請しないでください。{0}',
  'message.TKSCS00038W': '入力内容が編集されています。保存せずに続行しますか。',
  'message.TKSCS00039E': '{0}は、{1}の範囲で入力してください。',
  'message.TKSCS00040E': '登録可能な最大件数({0})を超過するため登録できません。',
  'message.TKSCS00041E': '検索結果:{0}件です。検索結果最大表示数(最大{1}行)を超える結果があります。検索条件を見直し再検索してください。',
  'message.TKSCS00042E': '該当{0}は、統合後のNW事業所に所属していない。{1}',
  'message.TKSCS00045E': '{0}は本日以前の日付を入力してください。{1}',
  'message.TKSCS00049E': '該当NW事業所は統合されています。統合後のNW事業所を再選択してください。',
  'message.TKSCS00050E': '申請時のお客さま情報が更新されています。変更内容はお客さま照会画面でご確認ください。{0}',
  'message.TKSCS00051E': '申請時のお客さま情報が更新されています。最申請が必要です。否決してくだい。',
  'message.TKSCS00052E': '基準年度が更新されています。否決して、再申請ください。',
  'message.TKSCZ00054E': '本登録が完了していません。\n本登録が完了しましたら再度アクセスをお願いします。',
  'message.TKSCZ00055E': '認証コードの有効期限が切れています。\n再度パスワードリセットを実施してください。',
  'message.TKSCZ00056E': '連続して実行されたため，一時的に処理が制限されています。\n少し時間をおいて再度実施をお願いします。',
  'message.TKSCZ00057E': '前回使用したパスワードは使用できません。\n新しいパスワードを入力してください。',
  'message.TKSCS00058C': '前画面に戻ります。よろしいですか。',
  'message.TKSCZ00060W': '入力内容が編集されています。{0}しますか。',
  'message.TKSCS00061E': '検索結果の件数が{0}件を超えています。画面は2000件を表示します。',
  'message.TKSCB00062E': '調査業種と調査理由が設定されたお客さまは選択できません。',
};
